import { REHYDRATE } from 'redux-persist';
import {
  ORG_FILTERS,
  PREDICTIVE_PROG_FEED_SUMM_FETCH
} from '../actions';

const INIT_STATE = {
  list: [],
  list_paging: { total_rows: 0, page_size: 25, page_indx: 0 },
  lead: null,
  feedback_insight: [],
  reviews: [],
  review_insight: [],
  org_filters: { parents: [], orgs: [] },
  pred_feed_summ: { all: null, negative_experience: null, purchased_vehicle_elsewhere: null, still_looking: null },
  grid_options: {
    lead: {
      crud_modal: null,
      crud_data: null,
      view: 'list',
      sort: 'asc',
      search: null,
      filters: {
      }
    }
  },
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PREDICTIVE_PROG_FEED_SUMM_FETCH.REQUEST: {
      return { ...state, pred_feed_summ: INIT_STATE.pred_feed_summ }
    }
    case PREDICTIVE_PROG_FEED_SUMM_FETCH.SUCCESS: {
      const {
        all,
        negative_experience,
        purchased_vehicle_elsewhere,
        still_looking
      } = action.payload
      return { ...state, pred_feed_summ: { all, negative_experience, purchased_vehicle_elsewhere, still_looking } }
    }
    case ORG_FILTERS.SUCCESS: {
      return { ...state, org_filters: action.payload }
    }    
    case REHYDRATE: {
      return INIT_STATE
    }
    default: return { ...state };
  }
}

export default handler
